import * as React from "react";

export const Copyright = () => {
  const org = process.env.ORGANISATION_NAME || "";
  const dateFrom = Number.parseInt(
    process.env.COPYRIGHT_FROM || new Date().getFullYear().toString(),
    10
  );
  const thisYear = new Date().getFullYear();
  const years =
    dateFrom === thisYear ? thisYear.toString() : `${dateFrom} - ${thisYear}`;

  return (
    <div className="copyright-text" data-testid="copyright">
      <div>
        © Copyright {org} {years}
      </div>
      <div>All Rights Reserved</div>
    </div>
  );
};
